import type {Editor, EditorConfig} from 'grapesjs';
import addRte from './rte';
import importStyle from './styles';
import importComponents from './components';
import importBlocks from './blocks';
import importStorages from './storages';
import importButtons from './buttons';
import addI18nMessages from './i18n';
import initCommands from './commands';
import initCustomStyleTypes from './custom-style-types';
import initListeners from './listeners';
import PMWEmailsNamespace from './var';
import importTouchInput from '@Utils/grapesjs-touch.util';

window.PMW.idEmailTemplate = null;
window.PMW.idEmailCampaign = $('#html-editor-container').attr('data-id-campaign') as string;

interface ConfigOptions {
  editor: Editor;
  pfx?: string;
  modalTitleImport?: string;
  modalTitleExport?: string;
  modalLabelImport?: string;
  modalLabelExport?: string;
  codeViewerTheme?: string;
  importPlaceholder?: string;
  defaultTemplate?: string;
  inlineCss?: number;
}

export type PrimaryConfigOptions = ConfigOptions & EditorConfig;

export default (editor: Editor, opts: PrimaryConfigOptions): void => {
  const c = <ConfigOptions>{...(opts || {})};
  const config = editor.getConfig();
  const pfx = config.stylePrefix;
  const defaults: ConfigOptions = {
    editor,
    pfx: pfx || '',
    modalTitleImport: 'Import template',
    modalTitleExport: 'Export template',
    modalLabelImport: '',
    modalLabelExport: '',
    codeViewerTheme: 'hopscotch',
    importPlaceholder: '',
    defaultTemplate: '', // Default template in case the canvas is empty
    inlineCss: 1,
  };

  // Change some config
  config.devicePreviewMode = true;

  let configKey;
  const updatedConfig: PrimaryConfigOptions = c;
  // eslint-disable-next-line no-restricted-syntax,guard-for-in
  for (const name in defaults) {
    configKey = name as keyof ConfigOptions;

    if (typeof c[configKey] === 'undefined') {
      // eslint-disable-next-line
      // @ts-ignore
      updatedConfig[configKey] = defaults[configKey];
    }
  }

  initEditor(updatedConfig);
};

/**
 * @param {PrimaryConfigOptions} config Configuration object
 * @private
 */
const initEditor = (config: PrimaryConfigOptions): void => {
  PMWEmailsNamespace();

  window.PMW.initTracking();

  initCommands(config);

  addRte(config);

  initCustomStyleTypes(config);

  importStyle(config);

  importComponents(config);

  importBlocks(config);

  importStorages(config);

  importButtons(config);

  addI18nMessages(config);

  initListeners(config);

  importTouchInput(config);
};
